import DOMPurify from "dompurify";

// Article and preview content is stored HTML. Stored content uses only paragraphs, bold, italics, line breaks
// and links; DOMPurify's HTML profile keeps those, plus inline styles, images and tables, and strips scripts,
// event handlers, javascript: URLs, embeds such as iframes, and SVG/MathML.
const sanitiseHtml = (html) => DOMPurify.sanitize(html ?? "", { USE_PROFILES: { html: true } });

export default sanitiseHtml;
